module.exports = __webpack_public_path__ + "img/mowerwalk_driving.4e30049e.svg";